import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUnread } from '../hooks/useUnread';
import { C, F } from './UI';

/* Global polling component. Mount once near the top of an authenticated layout.
   When new unread arrivals come in from /notifications/poll, surface a single
   popup (most recent item) with View / Close. */
export default function NotificationListener({ enabled = true }) {
  const { latest, clearLatest } = useUnread({ intervalMs: 30000, enabled });
  const [current, setCurrent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (latest && latest.length && !current) {
      setCurrent(latest[0]);
      clearLatest();
    }
  }, [latest, current, clearLatest]);

  const onView = useCallback(() => {
    const link = current?.link;
    setCurrent(null);
    if (link) navigate(link);
  }, [current, navigate]);

  const onClose = useCallback(() => setCurrent(null), []);

  if (!current) return null;

  return (
    <div role="alert" aria-live="polite" style={{
      position: 'fixed', right: 20, bottom: 20, zIndex: 1000,
      minWidth: 320, maxWidth: 380, background: '#fff',
      border: `1px solid ${C.border}`, borderLeft: `4px solid ${C.attn}`,
      borderRadius: 10, boxShadow: '0 12px 32px rgba(15,23,42,.18)',
      padding: '14px 16px', fontFamily: F,
      animation: 'hmNotifIn .22s ease-out',
    }}>
      <style>{`@keyframes hmNotifIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <span style={{ fontSize: 10, fontWeight: 800, color: '#fff', background: C.attn, padding: '2px 7px', borderRadius: 4, letterSpacing: '.08em' }}>NEW</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: C.ink, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {current.title}
        </span>
      </div>
      {current.body && (
        <div style={{ fontSize: 12, color: C.muted, marginBottom: 12, lineHeight: 1.4 }}>
          {current.body}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button onClick={onClose} style={{
          background: 'transparent', color: C.muted, border: `1px solid ${C.border}`,
          padding: '6px 14px', borderRadius: 6, fontFamily: F, fontSize: 12, fontWeight: 600, cursor: 'pointer',
        }}>Close</button>
        <button onClick={onView} style={{
          background: C.attn, color: '#fff', border: 'none',
          padding: '6px 14px', borderRadius: 6, fontFamily: F, fontSize: 12, fontWeight: 700, cursor: 'pointer',
        }}>View</button>
      </div>
    </div>
  );
}
